import { render, staticRenderFns } from "./DashboardDoughnut.vue?vue&type=template&id=19fc86a8"
import script from "./DashboardDoughnut.vue?vue&type=script&lang=js"
export * from "./DashboardDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports